import {CountryList} from "./CountryList";
import {CountryEdit} from "./CountryEdit";
import {CountryCreate} from "./CountryCreate";

export default {
    list: CountryList,
    create: CountryCreate,
    edit: CountryEdit
};
